/*
 * AddThis was retired in May 2023, it has been replaced here by ShareThis
 * Things haven't been renamed to avoid adverse impacts elsewhere in the solution
 */
import app from 'general/js/app';

let isLoaded = false;
let isLoading = false;
const onloadQueue = [];

function onLoad() {
    isLoaded = true;
    onloadQueue.forEach((callback) => callback(window.WINKWORTH_ShareThis));
}

function insertScript() {
    const pubId = app.getConfig('SHARE_THIS_CODE');
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = `https://platform-api.sharethis.com/js/sharethis.js#${pubId}`;
    const s = document.getElementsByTagName('script')[0];
    script.addEventListener('load', onLoad);
    s.parentNode.insertBefore(script, s);
}

export function onReady(callback) {
    if (isLoaded) {
        callback();
    } else {
        onloadQueue.push(callback);
    }
}

export function load() {
    if (!isLoading) {
        insertScript();
        isLoading = true;
    }
}

export default onReady;
